/// <amd-module name="Artifacts/Root/redux/Selectors" />

import { IRootModuleState } from "Artifacts/Root/redux/Contracts";
import { IFeed } from "Artifacts/Root/types";

export function getSelectedFeed(state: IRootModuleState): IFeed | undefined {
  return state.rootState.feed;
}
